import styled from "styled-components";

export const TestimonialsWrapper = styled.section.attrs({
  id: "testimonials",
})`
  .testimonial {
    /* background: var(--color-bg-variant); */
    text-align: center;
    /* padding: 0.1rem; */
    border-radius: 0.8rem;
   
    
    user-select: none;
  }
  .testimonials__container {
    width: 100%;
    

    @media screen and (max-width: 1024px) {
      width: 80%;
      height:300px;
    }
    @media screen and (min-width: 1024px) {
      width: 80%;
      height:350px;
    }
    @media screen and (max-width: 600px) {
      width: var(--container-width-sm);
      height:220px;
    }
    @media screen and (max-width: 280px) {
      width: var(--container-width-sm);
      height:200px;
    }
  }

  .swiper-pagination-clickable .swiper-pagination-bullet {
    background: var(--color-primary);
  }
`;

export const FirstText = styled.h5``;

export const SecondText = styled.h2``;

export const TestimonialsContainer = styled.div.attrs({
  className: "container",
})``;

export const TestimonialContainer = styled.article`
  /* background: var(--color-bg-variant); */
  text-align: center;
  padding: 0.1rem;
  border-radius: 1rem;
  user-select: none;
 
`;

export const TestimonialContainerClientAvatar = styled.div`
  width: 100%;
  height:100%;
  /* aspect-ratio: 1/1; */
  overflow: hidden;
 
  border-radius: 1rem;
  
  margin: 0 auto 0.5rem;
  border: 0.1rem solid var(--color-primary-variant);
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
  
`;

export const TestimonialContainerClientAvatarImage = styled.img`
  display: block;
  width:100%;
  height:100%;
  /* background-position-x: center;
  background-position-y: center;
   */
  background-size: cover;
  
  
`;

export const TestimonialContainerClientAvatarName = styled.h5``;

export const TestimonialContainerClientAvatarClientsReview = styled.small`
  color: var(--color-dark);
  font-weight: 300;
  display: block;
 
  width: 80%;
  margin: 0.8rem auto 0;
  @media screen and (max-width: 600px) {
    width: var(--container-width-sm);
  }
`;
